import { RootState } from "@root/rootReducer";
import { useCallback, useMemo } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { AccountSetting, GeneralSetting, PACSConnectionSetting, setacceptReceivingStudies, setAETitle, setAutomaticallyClearCacheFlag, setSeriesNumberBase, setCacheLimit, setDefaultServer, setEnableProxyServerFlag, setFont, setGPUAccelerationFlag, setStorageAlertNotificationFlag, setIntervalDay, setPort, setProxyIP, setProxyPort, setRenderingQualityType, setServerNode, setTheme, updateAccountSetting, updateGeneralSetting, updatePACSConnectionSetting } from "./SettingsModalSlice";
import { FontType, RenderingQualityKeyType, ThemeType } from "config/settingsConfig";
import { ServerNode } from "./SettingsModalSlice";
import { DicomNodeParams } from "@models/pacs";
export interface SettingsModalHookResult {
  general:GeneralSetting;
  pacsConnection: PACSConnectionSetting;
  account : AccountSetting;
  // General Settings
  setGeneralSetting:(partial: Partial<GeneralSetting>)=>void;
  setPACSConnectionSetting:(partial: Partial<PACSConnectionSetting>)=>void;
  setAccountSetting:(partial: Partial<AccountSetting>)=>void;

  handleTheme:(theme:ThemeType)=>void;
  handleFont:(font:FontType)=>void;
  handleCacheLimit:(limit:number)=>void;
  handleAutomaticallyClearCacheFlag:(flag:boolean)=>void;
  handleIntervalDay:(day:number)=>void;
  handleGPUAccelerationFlag:(flag:boolean)=>void;
  handleStorageAlertNotificationFlag:(flag:boolean)=>void;
  handleRenderingQualityType:(type:RenderingQualityKeyType)=>void;
  handleEnableProxyServerFlag:(flag:boolean)=>void;
  handleProxyIP:(ip:string)=>void;
  handleProxyPort:(port:string)=>void;
  handleAETitle:(aetitle:string)=>void;
  handlePort:(port:number)=>void;
  handleSeriesNumberBase:(seriesNumberBase:number)=>void;
  handleacceptReceivingStudies:(flag:boolean)=>void;
  handleServerNode:(node:ServerNode)=>void;
  handleDefaultServer:(nodes:DicomNodeParams[])=>void;
  // Pacs Settings
}

export const useSettingsModal = (): SettingsModalHookResult =>{
  const dispatch = useDispatch();

  const general = useSelector((state: RootState) => state.settings.data.general,shallowEqual);
  const pacsConnection = useSelector((state: RootState) => state.settings.data.pacsConnection,shallowEqual);
  const account = useSelector((state: RootState) => state.settings.data.account,shallowEqual);


  const setGeneralSetting = useCallback((partial: Partial<GeneralSetting>)=>{
    dispatch(updateGeneralSetting(partial))
  },[dispatch]);
  const setPACSConnectionSetting = useCallback((partial: Partial<PACSConnectionSetting>)=>{
    dispatch(updatePACSConnectionSetting(partial))
  },[dispatch]);
  const setAccountSetting = useCallback((partial: Partial<AccountSetting>)=>{
    dispatch(updateAccountSetting(partial))
  },[dispatch]);
  const handleTheme=useCallback((theme:ThemeType)=>dispatch(setTheme(theme)),[dispatch]);
  const handleFont=useCallback((font:FontType)=>dispatch(setFont(font)),[dispatch]);
  const handleCacheLimit=useCallback((limit:number)=>dispatch(setCacheLimit(limit)),[dispatch]);
  const handleAutomaticallyClearCacheFlag=useCallback((flag:boolean)=>dispatch(setAutomaticallyClearCacheFlag(flag)),[dispatch]);
  const handleIntervalDay=useCallback((day:number)=>dispatch(setIntervalDay(day)),[dispatch]);
  const handleGPUAccelerationFlag=useCallback((flag:boolean)=>dispatch(setGPUAccelerationFlag(flag)),[dispatch]);
  const handleStorageAlertNotificationFlag=useCallback((flag:boolean)=>dispatch(setStorageAlertNotificationFlag(flag)),[dispatch]);
  const handleRenderingQualityType=useCallback((type:RenderingQualityKeyType)=>dispatch(setRenderingQualityType(type)),[dispatch]);
  const handleEnableProxyServerFlag=useCallback((flag:boolean)=>dispatch(setEnableProxyServerFlag(flag)),[dispatch]);
  const handleProxyIP=useCallback((ip:string)=>dispatch(setProxyIP(ip)),[dispatch]);
  const handleProxyPort=useCallback((port:string)=>dispatch(setProxyPort(port)),[dispatch]);
  // PACS Setting - jjpark
  const handleAETitle=useCallback((AETitle:string)=>dispatch(setAETitle(AETitle)),[dispatch]);
  const handlePort=useCallback((port:number)=>dispatch(setPort(port)),[dispatch]);
  const handleSeriesNumberBase=useCallback((seriesNumberBase:number)=>dispatch(setSeriesNumberBase(seriesNumberBase)),[dispatch]);

  const handleacceptReceivingStudies=useCallback((flag:boolean)=>dispatch(setacceptReceivingStudies(flag)),[dispatch]);
  const handleServerNode=useCallback((serverNode:ServerNode)=>dispatch(setServerNode(serverNode)),[dispatch]);
  const handleDefaultServer=useCallback((nodes: DicomNodeParams[])=>dispatch(setDefaultServer(nodes)),[dispatch]);
  return useMemo(()=>({
    general,
    pacsConnection,
    account,
    setGeneralSetting,
    setPACSConnectionSetting,
    setAccountSetting,
    handleTheme
    ,handleFont
    ,handleCacheLimit
    ,handleAutomaticallyClearCacheFlag
    ,handleIntervalDay
    ,handleGPUAccelerationFlag
    ,handleStorageAlertNotificationFlag
    ,handleRenderingQualityType
    ,handleEnableProxyServerFlag
    ,handleProxyIP
    ,handleProxyPort
    ,handleAETitle
    ,handlePort
    ,handleSeriesNumberBase
    ,handleacceptReceivingStudies
    ,handleServerNode
    ,handleDefaultServer
  })
  ,[
    general,
    pacsConnection,
    account,
    setGeneralSetting,
    setPACSConnectionSetting,
    setAccountSetting,
    handleTheme
    ,handleFont
    ,handleCacheLimit
    ,handleAutomaticallyClearCacheFlag
    ,handleIntervalDay
    ,handleGPUAccelerationFlag
    ,handleStorageAlertNotificationFlag
    ,handleRenderingQualityType
    ,handleEnableProxyServerFlag
    ,handleProxyIP
    ,handleProxyPort
    ,handleAETitle
    ,handlePort
    ,handleSeriesNumberBase
    ,handleacceptReceivingStudies
    ,handleServerNode
    ,handleDefaultServer
  ])
}
